export const normalizeUser = (user) => {
  if (!user) return null;
  return {
    id: String(user.id || user.uid || ''),
    role: parseInt(user.role, 10) || 3,
  };
};

export const isAdmin = (user) => user?.role === 2;

export const isGuest = (user) => !user;

export const canReadTask = (task, user) => {
  if (!task) return false;
  if (task.visibility === 'public') return true;
  if (!user) return false;
  if (isAdmin(user)) return true;
  const uid = String(user.id);
  return String(task.created_by) === uid || String(task.assigned_to) === uid;
};

export const canWriteTask = (task, user) => {
  if (!user) return false;
  if (isAdmin(user)) return true;
  const uid = String(user.id);
  return String(task.created_by) === uid || String(task.assigned_to) === uid;
};

export const WRITE_ACTIONS = new Set([
  'tasks.create',
  'tasks.update',
  'tasks.delete',
  'tasks.duplicate',
  'tasks.complete',
  'tasks.reopen',
  'tasks.set_status',
  'tasks.set_priority',
  'tasks.set_due_date',
  'tasks.set_title',
  'tasks.set_description',
  'tasks.update_notes',
  'tasks.append_notes',
  'tasks.set_visibility',
  'tasks.assign',
  'tasks.unassign',
  'tasks.add_tags',
  'tasks.remove_tags',
  'tasks.set_tags',
  'tasks.checklist.add',
  'tasks.checklist.update',
  'tasks.checklist.toggle',
  'tasks.checklist.remove',
  'tasks.checklist.complete_all',
  'tasks.checklist.child.add',
  'tasks.checklist.child.update',
  'tasks.checklist.child.toggle',
  'tasks.checklist.child.remove',
  'tasks.bulk_update',
  'tasks.bulk_complete',
  'tasks.bulk_delete',
]);

export const isWriteAction = (action) => WRITE_ACTIONS.has(action);
